import React, { useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { getConfigClock } from "../../store/configSlice";
import dayjs from "dayjs";
import useInterval from "../../util/useInterval";
import style from "./index.module.css";

const UPDATE_TIME = 1000;

const Component = ({ clock }) => {
  const [datetime, setDatetime] = useState(dayjs(new Date()));
  useInterval(() => {
    setDatetime(dayjs(new Date()));
  }, UPDATE_TIME);

  return (
    <div className={style.container} style={clock.containerStyle}>
      <div className={style.time} style={clock.timeStyle}>
        {datetime.format(
          _.isEmpty(clock.timeFormat) ? "HH:mm:ss" : clock.timeFormat
        )}
      </div>
      <div className={style.date} style={clock.dateStyle}>
        {datetime.format(
          _.isEmpty(clock.dateFormat) ? "DD.MM.YYYY" : clock.dateFormat
        )}
      </div>
    </div>
  );
};

export default connect((state) => ({ clock: getConfigClock }))(Component);
